import '../App.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { getDevices } from '../QueryDevice';
import DeviceProfile from '../devices/DeviceProfile';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import img_tablet from '../tablet.png';
import CampaignStatus from './CampaignStatus';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate } from 'react-router-dom';

function CampaignDevices({ campaign_id }) {
    const navigate = useNavigate();

    const [devices, setDevices] = useState([]);
    const [edges, setEdges] = useState([]);

    function loadDevices() {
        getDevices().then(
            (response) => {
                setDevices(response.data);
            }
        ).catch(
            (error) => {
                console.log(error);
            }
        )
    }

    function loadEdges() {
        axios.get(
            process.env.REACT_APP_API_HOST + `/campaign/devices/?campaign_id=${campaign_id}`,
        ).then(
            (response) => {
                console.log(response.data.edges);
                setEdges(response.data.edges);
            }
        ).catch(
            (error) => {
                console.log(error);
            }
        )
    }

    function createEdge(campaign_id, device_id) {
        axios.post(
            process.env.REACT_APP_API_HOST + '/campaign/device/enable/',
            {
                campaign_id: campaign_id,
                device_id: device_id,
            },
        ).then(
            (response) => {
                loadEdges();
            }
        ).catch(
            (error) => {
                console.log(error);
            }
        )
    }

    function patchEdge(edge_id, data) {
        axios.patch(
            process.env.REACT_APP_API_HOST + `/campaignedgedevice/${edge_id}/`,
            data,
        ).then(
            (response) => {
                loadEdges();
            }
        ).catch(
            (error) => {
                console.log(error);
            }
        )
    }

    function getStatusForDevice(device) {
        const filtered = edges.filter(
            edge => edge.device_uuid == device.uuid && edge.status == 'active'
        )
        if (filtered.length > 0) {
            return 'active';
        }
        return 'inactive';
    }

    function getEdgeForDevice(device) {
        const filtered = edges.filter(
            edge => edge.device_uuid == device.uuid && edge.status == 'active'
        )
        if (filtered.length == 0) {
            return null;
        }
        return filtered[0];
    }

    function getCampaignStatus(device) {
        const status = getStatusForDevice(device);
        return <div>
            <CampaignStatus status={status} />
        </div>;
    }

    function getCampaignActions(device) {
        const status = getStatusForDevice(device);
        if (status == 'active') {
            return <div>
                <Button
                    severity='danger'
                    label='Stop'
                    size='small'
                    outlined
                    onClick={
                        () => {
                            const edge = getEdgeForDevice(device);
                            patchEdge(
                                edge.id,
                                {
                                    status: 'inactive'
                                }
                            )
                        }
                    }
                />
            </div>;
        }

        return <div>
            <Button
                severity='success'
                label='Start'
                size='small'
                outlined
                onClick={
                    () => createEdge(campaign_id, device.id)
                }
            />
        </div>;
    }

    useEffect(
        () => {
            loadDevices();
            loadEdges();
        },
        [campaign_id],
    )

    if (!edges || !devices) {
        return (
            <div>
                <ProgressSpinner />
            </div>
        );
    }

    return (
        <div>
            <DataTable
                value={devices}
                paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
            >
                <Column
                    key={1}
                    header='Screen'
                    field='title'
                    body={
                        (p) =>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                                onClick={
                                    () => {
                                        navigate(`/device/campaigns/?device_id=${p.id}`)
                                    }
                                }
                            >
                                <div style={{ marginRight: '1em' }}>
                                    <img src={img_tablet} width={42} />
                                </div>
                                <div>
                                    {p.title}
                                </div>
                            </div>
                    }
                />
                <Column
                    key={2}
                    header='Campaign Status'
                    field='status'
                    body={
                        (p) => getCampaignStatus(p)
                    }
                />
                <Column
                    key={2}
                    header='Actions'
                    field='status'
                    body={
                        (p) => getCampaignActions(p)
                    }
                />
            </DataTable>
        </div>
    );
}

export default CampaignDevices;